import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ComboboxInput from '../../infra/components/formInput/ComboboxInput' 

import ActionAdd from '../../store/action/Supervisor/Add'
import ActionGetAllUser from '../../store/action/Account/FetchAll'
import ActionEdit from '../../store/action/Supervisor/Edit'
import {IsEdit, IsCreate, IsView } from '../../store/constants'

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'spv-id' : '',
        'spv-name' : '',
        'username' : '',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount(){
    this.props.actionGetAllUser();
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    if(field === 'username'){
      formVal = formVal.set('spv-name',label); 
    }
    this.setState({ form:formVal })
  }

  async handleSubmit(dispatch) {
    const {form} = this.state;
    var isValid = true;
    const mandatoryField = fromJS(['spv-name', 'username'])
    
    var newErrors = fromJS({});
    mandatoryField.map((field) => {
        if(form.get(field) === ''){
          isValid = false;
          newErrors = newErrors.set(field)
        }
    })

    this.setState({ errors: newErrors })

    if(!isValid){
      toast.error("Mandatory Field Cannot Empty!",toast.POSITION.TOP_RIGHT)
    }

    if(isValid){

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code blocks
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'data' : 
            {
                'spv-name' : form.get('spv-name'),
                'username' : form.get('username'),
            }
        };

        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          //toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  async SubmitEditData(){
    const form = this.state.form;
    var data = 
        {
          'data' : {
                'spv-id': form.get('spv-id'),
                'spv-name': form.get('spv-name'),
                'username': form.get('username'),
            }
        };

        var response = await this.props.actionEdit(data);
        if(response.ok){
          toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          //toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
        this.setState({
          form:  fromJS({
            'spv-id' : this.props.item.get('spv-id'), 
            'spv-name' : this.props.item.get('spv-name'),
            'username' : this.props.item.get('username'),
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled } = this.state;
    let disabledOnEdit = disabled
    if(this.props.actionType === IsEdit){
      disabledOnEdit = true
    }
    return (
      <div className="card no-margin-bottom">
        <div className="body">
          <div className="row no-margin-bottom">
              <span className="col-sm-2">User *</span>
              <div className="col-sm-10">
                  <ComboboxInput
                    field='username'
                    value={form.get('username')}
                    options={fromJS({
                        'source': this.props.userall,
                        'value': 'username',
                        'label': 'full-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="User"
                    disabled={disabledOnEdit}
                    hasError={errors.has('username')}
                  />
              </div>
          </div>

          {this.renderFormName(form, errors)} 

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-6">
            <button type="button"
                  className="btn btn-width btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button"
                  className="btn btn-width btn-success"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
        </div>
    );
  }

  renderFormName(form, errors){
    if(this.props.actionType === IsEdit){
      return(
        <div className="row no-margin-bottom">
              <span className="col-sm-2">Name</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'spv-name'}
                      value={ form.get('spv-name')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="name"
                      hasError={errors.has('spv-name')}
                  />
              </div>
        </div>
      )
    }
  }

}


export default connect(
  (state) => {
      return {
          Users: state.user.users,
          userall: state.user.userall,
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionEdit: ActionEdit,
      actionGetAllUser: ActionGetAllUser,
  }, dispatch),
)(Form);